/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils

/* ++++++++++ --------------- EXPORT : COMMENT IMPORTER TOOL : STYLES --------------- ++++++++++ */
export default theme =>({
  moderationconfigpage: {
    '& .pageheader': { 
      maxWidth: '80em',
      alignItems: 'end',
      '& .name-dashboardbtn': {
        height: pxToEm(40),
        fontSize: pxToEm(12),
        '& .icon': { fontSize: pxToEm(12) }
      }
    }
  }
});
